<template>
  <van-swipe :autoplay="3000" indicator-color="white" v-if="bannerList.length">
    <van-swipe-item v-for="(item, index) in bannerList" :key="index">
      <img
        :src="item.pic_url"
        alt=""
        class="banner"
        @click="handleBanner(item)"
      />
    </van-swipe-item>
  </van-swipe>
  <div v-else class="van_swipe_other">
    <img src="@/assets/image/internal/swiper.webp" alt="" class="banner" />
  </div>
</template>

<script>
export default {
  props: {
    bannerList: Array,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    handleBanner(item) {
      console.log(JSON.stringify(item));
      window.android.clickBanner(JSON.stringify(item));
    },
  },
};
</script>
<style lang="scss" scoped>
.van-swipe,
.van_swipe_other {
  height: 1.6rem;
  .banner {
    width: 6.6rem;
    height: 1.6rem;
    border-radius: 0.1rem;
  }
}
.van_swipe_other {
  display: flex;
  justify-content: center;
}
</style>
